import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import {Card} from '../../../card-container/card/card';
import {Student360Service} from '../../../../student360.service';
import {UserService} from '../../../../../shared-components/user/user.service';
import {StudentService} from '../../../../../shared-components/student/student.service';
import {YearService} from '../../../../../shared-components/year/year.service';
import {StudentSummaryService} from '../../../student-summary.service';
import {CardStudentEnrollment} from './card-student-enrollment';
import {TylerMatTableDataSource} from '../../../../../shared-components/angular-material/extended.class';
import {detailExpand} from '../../../../../shared-components/angular-material/mat-animations';
import {MatDialog} from '@angular/material/dialog';
import {MembershipCodeDetailsModalComponent} from './membership-code-details-modal/membership-code-details-modal.component';
import {LoginService} from '../../../../../shared-modules/login/login.service';

@Component({
    selector: 'app-enrollment-card',
    templateUrl: './enrollment-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./enrollment-card.component.css'],
    // Animation for when the detail row is expanded or collapsed
    animations: [detailExpand]
})
export class EnrollmentCardComponent implements OnInit, OnDestroy {

    @Input() data: any;
    subscriptions: Subscription[] = [];
    card: Card;
    // Angular Material Table
    displayedColumns: string[] = ['priorDistrict', 'priorState', 'priorCountry'];
    historyColumns: string[] = ['year', 'school', 'grade', 'enrolled', 'more'];
    angularMatData = new TylerMatTableDataSource();
    enrollmentHistory: CardStudentEnrollment[] = [];
    enrollmentDetails: CardStudentEnrollment[] = [];
    constructor(
        private student360Service: Student360Service,
        private userService: UserService,
        private cdr: ChangeDetectorRef,
        private studentService: StudentService,
        private yearService: YearService,
        private studentSummaryService: StudentSummaryService,
        private dialog: MatDialog,
        private loginService: LoginService
    ) {
    }

    ngOnInit() {
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getEnrollmentHistory();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    getEnrollmentHistory() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardStudentEnrollment(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier).subscribe((response) => {
            if (response.ok) {
                this.enrollmentHistory = response.body;
                this.enrollmentDetails = this.enrollmentHistory.filter(e => e.IsCurrent == true);
                this.angularMatData.data = this.enrollmentHistory;
                // Because we are using on push change detection trigger cd
                this.updateView();
            }
        });
    }

    updateView() {
        this.cdr.detectChanges();
    }

    openMembershipCodeDetails(RSNY_ID: number, membershipCode: string) {
        this.dialog.open(MembershipCodeDetailsModalComponent, {disableClose: true, minWidth: '60vw', autoFocus: false, data: {RSNY_ID: RSNY_ID, membershipCode: membershipCode}});
    }

    // ----------Angular Material------------------------------------
    // These methods are used to allow calls to the TylerMatTableDataSource methods from the html
    toggleExpanded(row: any) {
        // Toggles row between expanded and collapsed
        this.angularMatData.toggleExpanded(row);
    }

    checkExpanded(row: any): boolean {
        // Return true if expanded and false if collapsed
        return this.angularMatData.checkExpanded(row);
    }

    expandAll(expand: boolean) {
        //  Expand or collapse all rows
        //  true => expand all    false => collapse all
        this.angularMatData.expandAll(expand);
    }

    rowKeyPress(event: KeyboardEvent, row: any) {
        this.angularMatData.rowKeyPress(event, row);
    }

}
